import React from "react";

import { WeedfettiCannon } from "./WeedfettiCannon";
import { WeedfettiProvider } from "./WeedfettiContext";

export const WeedfettiFrame: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <WeedfettiProvider>
      {children}
      <WeedfettiCannon />
    </WeedfettiProvider>
  );
};
